import script from "./PartnerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerCard.vue?vue&type=script&setup=true&lang=js"

import "./PartnerCard.vue?vue&type=style&index=0&id=715f6340&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715f6340"]])

export default __exports__